import { Col, Media, Row } from "reactstrap";
import { H3, H4, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Invoice } from "../../../../../Constants/Constants";

const InvoiceSixHeader = () => {
  return (
    <div>
      <Row>
        <Col sm="6">
          <Media className="d-flex">
            <div className="media-left">
              <Image className="media-object img-80 for-light" src={dynamicImage(`other-images/logo-login.png`)} alt="logo-light" />
              <Image className="media-object img-80 for-dark" src={dynamicImage(`other-images/logo_dark.png`)} alt="logo-dark" />
            </div>
            <Media body className="text-right m-l-20 text-start ">
              <H4 className="media-heading">Moscow</H4>
              <P>
                hello@moscow.in
                <br />
                <span>289-335-6503</span>
              </P>
            </Media>
          </Media>
        </Col>
        <Col sm="6">
          <div className="text-md-end text-xs-center">
            <H3>
              {Invoice} #<span className="counter">1069</span>
            </H3>
            <P>
              Issued: May<span> 27, 2025</span>
              <br /> Payment Due: June <span>27, 2025</span>
            </P>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default InvoiceSixHeader;
